import React from "react";
import styled from "styled-components";

const Input = styled.input.attrs({
    type: "number",
})`
    pointer-events: all;
    outline: none;
    direction: ltr;
    margin: 0 2px 0 0;
    border: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    font-family: "Source Code Pro", monospace;
    text-align: right;
    color: #fff;
    background-color: transparent;
`;

type Props = {
    value: number;
    onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
};

export default class TextField extends React.Component<Props> {
    preventEvent = (evt: React.MouseEvent | React.FocusEvent) => {
        evt.preventDefault();
        evt.stopPropagation();
    };

    render() {
        return (
            <Input
                value={this.props.value}
                onChange={this.props.onChange}
                onFocus={this.preventEvent}
                onClick={this.preventEvent}
            />
        );
    }
}
